// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","educationList":"_3FDZhQ47yKv1ll9prRNqk-","educationDegreeInfo":"_3luXC7z19VWTsEd8e43pWV"};